<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { SimpleBar } from "simplebar-vue3"
import WalletBalance from "./wallet-balance.vue";
import Overview from "./overview.vue";
import Loader from "../../components/loader";
import api from "@/axios";

import {
  walletRadialChart,
  overviewChart,
  transactionsData,
  bitconinChart,
  ethereumChart,
  litecoinChart,
} from "./data";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Analítico",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, SimpleBar, WalletBalance, Overview, Loader },
  data() {
    return {
      updating: true,
      walletRadialChart: walletRadialChart,
      overviewChart: overviewChart,
      transactionsData: transactionsData,
      bitconinChart: bitconinChart,
      ethereumChart: ethereumChart,
      litecoinChart: litecoinChart,
      title: "Analítico",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Analítico",
          active: true,
        },
      ],
    };
  },
  mounted() {
    console.log('mounted_dashAnalitico')


    // var container2 = document.querySelector(
    //   "#containerElement .simplebar-content-wrapper"
    // );
    // container2.scrollTo({ top: 500, behavior: "smooth" });

    api.get(`${getBaseUrl()}api/testarapiauth`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    })

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 340px;">
    </Loader>

      <div class="row" v-if="!updating">
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <b-dropdown
                class="float-end ms-2"
                variant="white"
                right
                toggle-class="text-muted p-0"
                menu-class="dropdown-menu-end"
              >
                <template v-slot:button-content>
                  <i class="mdi mdi-dots-horizontal font-size-18"></i>
                </template>
                <b-dropdown-item>Action</b-dropdown-item>
                <b-dropdown-item>Another action</b-dropdown-item>
                <b-dropdown-item>Something else here</b-dropdown-item>
              </b-dropdown>
              <div>
                <div class="mb-4 me-3">
                  <i class="mdi mdi-account-circle text-primary h1"></i>
                </div>

                <div>
                  <h5>Maria da Silva</h5>
                  <p class="text-muted mb-1">mariasilva@apresentacao.com.br</p>
                  <p class="text-muted mb-0">Id no: #SK0234</p>
                </div>
              </div>
            </div>

            <div class="card-body border-top">
              <div class="row">
                <div class="col-sm-6">
                  <div>
                    <p class="fw-medium mb-2">Acumulado mês:</p>
                    <h4>R$ 610.340,39</h4>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mt-4 mt-sm-0">
                    <p class="fw-medium mb-2">Estados:</p>
                    <div class="d-inline-flex align-items-center mt-1">

                      <a href="javascript: void(0);"
                         class="m-1"
                         v-b-tooltip.hover
                         data-placement="top"
                         title="Rio de Janeiro">

                        <div class="avatar-xs">
                          <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                            RJ
                          </span>
                        </div>

                      </a>

                      <a href="javascript: void(0);"
                         class="m-1"
                         v-b-tooltip.hover
                         data-placement="top"
                         title="Espírito Santo">

                        <div class="avatar-xs">
                          <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                            ES
                          </span>
                        </div>

                      </a>

                      <a href="javascript: void(0);"
                         class="m-1"
                         v-b-tooltip.hover
                         data-placement="top"
                         title="Minas Gerais">

                        <div class="avatar-xs">
                          <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                            MG
                          </span>
                        </div>

                      </a>


                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer bg-transparent border-top">
              <div class="text-center">
                <router-link to="/orcamentos/list"
                  href="javascript: void(0);"
                  class="btn btn-outline-light me-2 w-md"
                  >Orçamentos</router-link
                >
                <router-link to="/pedidos/list" href="javascript: void(0);" class="btn btn-primary me-2 w-md"
                  >Pedidos</router-link
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-8">
          <div class="card">
            <div>
              <div class="row">
                <div class="col-lg-9 col-sm-8">
                  <div class="p-4">
                    <h5 class="text-primary">Bem vindo!</h5>
                    <p>Dashboard analítico</p>

                    <div class="text-muted">
                      <p class="mb-1">
                        <i
                          class="mdi mdi-circle-medium align-middle text-primary me-1"
                        ></i>
                        8 novos orçamentos hoje
                      </p>
                      <p class="mb-1">
                        <i
                          class="mdi mdi-circle-medium align-middle text-primary me-1"
                        ></i>
                        64 pedidos convertidos nesta semana
                      </p>
                      <p class="mb-0">
                        <i
                          class="mdi mdi-circle-medium align-middle text-primary me-1"
                        ></i>
                        R$ 240.000,00 faturado
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-4 align-self-center">
                  <div>
                    <img
                      src="@/assets/images/crypto/features-img/img-1.png"
                      alt
                      class="img-fluid d-block"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="card">
                <div class="card-body">
                  <p class="text-muted mb-4">
                    <i
                      class="mdi mdi-shopping h2 text-warning align-middle mb-0 me-3"
                    ></i>
                    Orçamentos semana
                  </p>

                  <div class="row">
                    <div class="col-6">
                      <div>
                        <h5>R$ 9.134,39</h5>
                        <p class="text-muted text-truncate mb-0">
                          + 0.0012 ( 0.2 % )
                          <i class="mdi mdi-arrow-up ms-1 text-success"></i>
                        </p>
                      </div>
                    </div>
                    <div class="col-6">
                      <div>
                        <apexchart
                          class="apex-charts"
                          height="40"
                          type="area"
                          dir="ltr"
                          :series="bitconinChart.series"
                          :options="bitconinChart.chartOptions"
                        ></apexchart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="card">
                <div class="card-body">
                  <p class="text-muted mb-4">
                    <i
                      class="mdi mdi-cart-arrow-down h2 text-primary align-middle mb-0 me-3"
                    ></i>
                    Pedidos semana
                  </p>

                  <div class="row">
                    <div class="col-6">
                      <div>
                        <h5>R$ 245.854,00</h5>
                        <p class="text-muted text-truncate mb-0">
                          - 4.102 ( 0.1 % )
                          <i class="mdi mdi-arrow-down ms-1 text-danger"></i>
                        </p>
                      </div>
                    </div>
                    <div class="col-6">
                      <div>
                        <apexchart
                          class="apex-charts"
                          height="40"
                          type="area"
                          dir="ltr"
                          :series="ethereumChart.series"
                          :options="ethereumChart.chartOptions"
                        ></apexchart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="card">
                <div class="card-body">
                  <p class="text-muted mb-4">
                    <i
                      class="mdi mdi-cash h2 text-info align-middle mb-0 me-3"
                    ></i>
                    Faturado mês
                  </p>

                  <div class="row">
                    <div class="col-6">
                      <div>
                        <h5>R$ 6.614.800,00</h5>
                        <p class="text-muted text-truncate mb-0">
                          + 1.792 ( 0.1 % )
                          <i class="mdi mdi-arrow-up ms-1 text-success"></i>
                        </p>
                      </div>
                    </div>
                    <div class="col-6">
                      <div>
                        <apexchart
                          class="apex-charts"
                          height="40"
                          type="area"
                          dir="ltr"
                          :series="litecoinChart.series"
                          :options="litecoinChart.chartOptions"
                        ></apexchart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <Loader v-if="updating" style="min-height: 340px;" class="mt-4">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-xl-8">
        <WalletBalance />
      </div>
      <div class="col-xl-4">
        <Overview />
      </div>
    </div>

    <Loader v-if="updating" style="min-height: 100px;" class="mt-4">
    </Loader>


    <div class="row" v-if="!updating">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Últimos Orçamentos</h4>
            <b-tabs pills nav-class="bg-light rounded" content-class="mt-4">
              <b-tab title="Todos" active>
                <b-card-text>
                  <SimpleBar style="max-height: 330px">
                    <table
                      class="table table-centered table-nowrap align-middle"
                    >
                      <tbody>
                        <tr v-for="data of transactionsData" :key="data.icon">
                          <td style="width: 50px">
                            <div :class="`font-size-22 text-${data.color}`">
                              <i
                                :class="{
                                  'bx bx-down-arrow-circle':
                                    `${data.color}` === 'primary',
                                  'bx bx-up-arrow-circle':
                                    `${data.color}` === 'danger',
                                }"
                              ></i>
                            </div>
                          </td>
                          <td>
                            <div>
                              <h5 class="font-size-14 mb-1">{{ data.name }}</h5>
                              <p class="text-muted mb-0">{{ data.date }}</p>
                            </div>
                          </td>
                          <td>
                            <div class="text-end">
                              <h5 class="font-size-14 mb-0">{{ data.text }}</h5>
                            </div>
                          </td>
                          <td>
                            <div class="text-end">
                              <h5 class="font-size-14 text-muted mb-0">
                                {{ data.price }}
                              </h5>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </SimpleBar>
                </b-card-text>
              </b-tab>
              <b-tab title="Elaboração">
                <b-card-text>
                  <SimpleBar style="max-height: 330px">
                    <table
                      class="table table-centered table-nowrap align-middle"
                    >
                      <tbody>
                        <tr v-for="data of transactionsData" :key="data.id">
                          <td style="width: 50px">
                            <div :class="`font-size-22 text-${data.color}`">
                              <i
                                :class="{
                                  'bx bx-down-arrow-circle':
                                    `${data.color}` === 'primary',
                                  'bx bx-up-arrow-circle':
                                    `${data.color}` === 'danger',
                                }"
                              ></i>
                            </div>
                          </td>
                          <td>
                            <div>
                              <h5 class="font-size-14 mb-1">{{ data.name }}</h5>
                              <p class="text-muted mb-0">{{ data.date }}</p>
                            </div>
                          </td>
                          <td>
                            <div class="text-end">
                              <h5 class="font-size-14 mb-0">{{ data.text }}</h5>
                            </div>
                          </td>
                          <td>
                            <div class="text-end">
                              <h5 class="font-size-14 text-muted mb-0">
                                {{ data.price }}
                              </h5>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </SimpleBar>
                </b-card-text>
              </b-tab>
              <b-tab title="Confirmados">
                <b-card-text>
                  <SimpleBar style="max-height: 330px">
                    <table
                      class="table table-centered table-nowrap align-middle"
                    >
                      <tbody>
                        <tr v-for="data of transactionsData" :key="data.id">
                          <td style="width: 50px">
                            <div :class="`font-size-22 text-${data.color}`">
                              <i
                                :class="{
                                  'bx bx-down-arrow-circle':
                                    `${data.color}` === 'primary',
                                  'bx bx-up-arrow-circle':
                                    `${data.color}` === 'danger',
                                }"
                              ></i>
                            </div>
                          </td>
                          <td>
                            <div>
                              <h5 class="font-size-14 mb-1">{{ data.name }}</h5>
                              <p class="text-muted mb-0">{{ data.date }}</p>
                            </div>
                          </td>
                          <td>
                            <div class="text-end">
                              <h5 class="font-size-14 mb-0">{{ data.text }}</h5>
                            </div>
                          </td>
                          <td>
                            <div class="text-end">
                              <h5 class="font-size-14 text-muted mb-0">
                                {{ data.price }}
                              </h5>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </SimpleBar>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Notificações</h4>
            <ul class="list-group">
              <SimpleBar style="max-height: 390px">

                <li class="list-group-item border-0">
                  <div class="d-flex">
                    <div class="avatar-xs me-3">
                        <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                          MG
                        </span>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-14">Pedido Faturado 885670</h5>
                      <p class="text-muted">
                        R$ 17.850,00
                      </p>
                      <div class="float-end">
                        <p class="text-muted mb-0">
                          <i class="mdi mdi-account me-1"></i> Cliente Testes 099
                        </p>
                      </div>
                      <p class="text-muted mb-0">12 Mar, 2023</p>
                    </div>
                  </div>
                </li>

                <li class="list-group-item border-0">
                  <div class="d-flex">
                    <div class="avatar-xs me-3">
                        <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                          RJ
                        </span>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-14">Pedido Faturado 0055874</h5>
                      <p class="text-muted">
                        R$ 34.455,00
                      </p>
                      <div class="float-end">
                        <p class="text-muted mb-0">
                          <i class="mdi mdi-account me-1"></i> Cliente Testes 001
                        </p>
                      </div>
                      <p class="text-muted mb-0">11 Mar, 2023</p>
                    </div>
                  </div>
                </li>

                <li class="list-group-item border-0">
                  <div class="d-flex">
                    <div class="avatar-xs me-3">
                        <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                          MG
                        </span>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-14">Orçamento em elaboração 477587</h5>
                      <p class="text-muted">
                        R$ 8.004,55
                      </p>
                      <div class="float-end">
                        <p class="text-muted mb-0">
                          <i class="mdi mdi-account me-1"></i> Cliente Testes 099
                        </p>
                      </div>
                      <p class="text-muted mb-0">11 Mar, 2023</p>
                    </div>
                  </div>
                </li>

                <li class="list-group-item border-0">
                  <div class="d-flex">
                    <div class="avatar-xs me-3">
                        <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                          MG
                        </span>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-14">Orçamento em elaboração 477580</h5>
                      <p class="text-muted">
                        R$ 11.999,14
                      </p>
                      <div class="float-end">
                        <p class="text-muted mb-0">
                          <i class="mdi mdi-account me-1"></i> Cliente Testes 099
                        </p>
                      </div>
                      <p class="text-muted mb-0">10 Mar, 2023</p>
                    </div>
                  </div>
                </li>





              </SimpleBar>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Novos Clientes</h4>
            <b-tabs pills nav-class="bg-light rounded" content-class="mt-4">
              <b-tab title="Último" active>
                <b-card-text>
                  <div class="float-end ms-2">
                    <h5 class="font-size-14">
                      <i
                        class="bx bx-wallet text-primary font-size-16 align-middle me-1"
                      ></i>
                      R$ 35.100,00
                    </h5>
                  </div>
                  <h5 class="font-size-14 mb-4">Limite de crédito</h5>
                  <div>
                    <div class="form-group mb-3">
                      <label for="inputNome">Nome:</label>
                      <input id="inputNome" type="text" class="form-control" value="Cliente Testes 998" disabled="true"/>
                    </div>
                    <div class="form-group mb-3">
                      <label for="inputCidade">Cidade:</label>
                      <input id="inputCidade" type="text" class="form-control" value="Vitória" disabled="true"/>
                    </div>
                    <label for="inputValor">Última Compra:</label>
                      <div class="input-group mb-3">
                        <input id="inputValor" type="text" class="form-control" value="0,00" disabled="true"/>
                        <div class="input-group-append">
                          <label for="inputValor" class="input-group-text">R$</label>
                        </div>
                      </div>
                    <div class="text-center">
                      <button type="button" class="btn btn-success w-md" @click="$router.push('/clientes/list')">
                        Mais detalhes
                      </button>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab title="Penúltimo">
                <b-card-text>
                  <div class="float-end ms-2">
                    <h5 class="font-size-14">
                      <i
                          class="bx bx-wallet text-primary font-size-16 align-middle me-1"
                      ></i>
                      R$ 42.350,23
                    </h5>
                  </div>
                  <h5 class="font-size-14 mb-4">Limite de crédito</h5>
                  <div>
                    <div class="form-group mb-3">
                      <label for="inputNome02">Nome:</label>
                      <input id="inputNome02" type="text" class="form-control" value="Cliente Testes 999" disabled="true"/>
                    </div>
                    <div class="form-group mb-3">
                      <label for="inputCidade02">Cidade:</label>
                      <input id="inputCidade02"  type="text" class="form-control" value="Vitória" disabled="true"/>
                    </div>
                    <label for="inputValor02">Última Compra:</label>
                    <div class="input-group mb-3">
                      <input id="inputValor02" type="text" class="form-control" value="40.000,00" disabled="true"/>
                      <div class="input-group-append">
                        <label for="inputValor02" class="input-group-text">R$</label>
                      </div>
                    </div>
                    <div class="text-center">
                      <button type="button" class="btn btn-success w-md">
                        Mais detalhes
                      </button>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
